document.querySelectorAll('.header nav a').forEach(link => {
  const target = new URL(link.href, location.href).pathname.replace(/\/$/, '');
  if (target === location.pathname.replace(/\/$/, '')) link.setAttribute('aria-current', 'page');
});
// Enhance existing themes without changing Liquid, artist settings, or page content.
const playerStyles = document.createElement('style');
playerStyles.id = 'f2thak-image-player-styles';
playerStyles.textContent = `
.artist-cover .art-player{display:block;position:relative;width:100%;height:100%;padding:0;border:0;background:transparent;color:white;cursor:pointer}
.artist-cover .art-player:focus-visible{outline:3px solid var(--red);outline-offset:-5px}
.art-play-icon{position:absolute;right:18px;bottom:18px;width:52px;height:52px;display:flex;align-items:center;justify-content:center;padding-left:3px;border:1px solid #ffffff88;border-radius:50%;background:#101010b8;font-size:1.15rem;pointer-events:none}
.art-player:hover .art-play-icon,.art-player:focus-visible .art-play-icon{background:var(--red);color:#111}
.artist-number{pointer-events:none}
`;
if (!document.getElementById(playerStyles.id)) document.head.append(playerStyles);
function enableArtworkPlayers(root = document) {
  root.querySelectorAll('.artist').forEach(artist => {
    const cover = artist.querySelector('.artist-cover');
    if (!cover || !cover.querySelector('img') || cover.querySelector('button, a')) return;
    const previewButton = artist.querySelector('[data-player]');
    let playerUrl = previewButton?.dataset.player;
    if (!playerUrl) {
      const link = artist.querySelector('.listen');
      if (!link) return;
      try {
        const url = new URL(link.href);
        const match = url.pathname.match(/^\/(?:intl-[^/]+\/)?(artist|album|track|playlist)\/([a-zA-Z0-9]+)\/?$/);
        if (url.origin !== 'https://open.spotify.com' || !match) return;
        playerUrl = `https://open.spotify.com/embed/${match[1]}/${match[2]}`;
      } catch { return; }
    }
    const name = artist.querySelector('h3')?.textContent.trim() || 'Artist';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'art-player';
    button.dataset.player = playerUrl;
    button.dataset.title = name;
    button.setAttribute('aria-label', `Open ${name} music player`);
    button.setAttribute('aria-expanded', 'false');
    const icon = document.createElement('span');
    icon.className = 'art-play-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '▶';
    button.append(...cover.childNodes, icon);
    cover.append(button);
  });
}
enableArtworkPlayers();
document.addEventListener('shopify:section:load', event => enableArtworkPlayers(event.target));
let playerCount = 0;
document.addEventListener('click', event => {
  const button = event.target.closest('[data-player]');
  if (!button) return;
  let url;
  try { url = new URL(button.dataset.player); } catch { return; }
  if (url.origin !== 'https://open.spotify.com' || !url.pathname.startsWith('/embed/')) return;
  const artist = button.closest('.artist');
  if (!artist) return;
  let container = artist.querySelector('.player-wrap');
  if (!container) {
    container = document.createElement('div');
    container.className = 'player-wrap';
    artist.append(container);
  }
  if (!container.id) container.id = `artist-player-${++playerCount}`;
  let frame = container.querySelector('iframe');
  if (!frame) {
    frame = document.createElement('iframe');
    frame.src = url.href;
    frame.title = `${button.dataset.title} — Spotify music player`;
    frame.className = 'spotify-player';
    frame.allow = 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.tabIndex = 0;
    container.replaceChildren(frame);
  }
  artist.querySelectorAll('[data-player]').forEach(control => {
    control.setAttribute('aria-expanded', 'true');
    control.setAttribute('aria-controls', container.id);
  });
  container.scrollIntoView({ block: 'nearest', behavior: 'instant' });
  frame.focus();
});
